import { render, staticRenderFns } from "./Levenswegbutton.vue?vue&type=template&id=88ae5a5a&"
import script from "./Levenswegbutton.vue?vue&type=script&lang=js&"
export * from "./Levenswegbutton.vue?vue&type=script&lang=js&"
import style0 from "./Levenswegbutton.vue?vue&type=style&index=0&id=88ae5a5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports